import { Box, ListItemIcon, ListItemText, MenuList } from '@mui/material';
import { FC } from 'react';
import { ISidebarItem } from 'types/models/Sidebar';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'redux/hooks';

import { ADMIN_MAIN_MENU_ITEMS,
  COORDINATOR_EVENT_MAIN_MENU_ITEMS,
  MANAGER_EVENT_MAIN_MENU_ITEMS,
  MANAGER_SEAT_MAIN_MENU_ITEMS } from 'components/sidebar/constants';
import { LanguageSwitcher } from './LanguageSwitcher';
import { LogoutButton } from './LogoutButton';
import { UserInfoBlock } from './UserInfoBlock';

import { menuListSx, sidebarContainerSx, StyledMenuItem } from './styles';

type TRoleType = 'manager_event' | 'manager_seat' | 'admin' | 'coordinator_event';

/**
 * Сайдбар с боковым меню
 */
export const Sidebar: FC = () => {
  const { t, i18n: { language, changeLanguage } } = useTranslation();

  const { data } = useAppSelector(state => state.eventUser);

  const role: TRoleType = data?.role.name as TRoleType || 'manager_event';
  const MAIN_MENU_ITEMS = {
    manager_event: MANAGER_EVENT_MAIN_MENU_ITEMS,
    manager_seat: MANAGER_SEAT_MAIN_MENU_ITEMS,
    admin: ADMIN_MAIN_MENU_ITEMS,
    superadmin: ADMIN_MAIN_MENU_ITEMS,
    coordinator_event: COORDINATOR_EVENT_MAIN_MENU_ITEMS
  };

  /**
   * Разделы бокового меню
   * @param item - элемент бокового меню
   * @returns JSX-элемент пункта меню
   */
  const renderMenuItem = (item: ISidebarItem) => (
    <StyledMenuItem to={item.url} key={item.id}>
      <ListItemIcon>
        <item.Icon />
      </ListItemIcon>
      <ListItemText>{t(item.label)}</ListItemText>
    </StyledMenuItem>
  );

  /**
   * Рендер основного компонента
   */
  const renderContent = () => (
    <Box sx={sidebarContainerSx}>
      <Box display='flex' flexDirection='column' alignItems='center' height='100%'>
        <UserInfoBlock />

        <MenuList sx={menuListSx}>
          {MAIN_MENU_ITEMS[role].map(item => renderMenuItem(item))}
        </MenuList>

        <LanguageSwitcher language={language} onChange={changeLanguage} />

        <LogoutButton />
      </Box>
    </Box>
  );

  return renderContent();
};
